module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_3_A i B.1529f3cd.mp3";